module.exports = __webpack_public_path__ + "static/media/caducado.d283a186.png";